import { Component, OnInit,  HostListener, ElementRef, ViewChild, OnDestroy, Input, Inject } from '@angular/core';
import { RechargeBoxService } from '../../_service/recharge-box/recharge-box.service';
import { Router, NavigationEnd } from '../../../../node_modules/@angular/router';
import { environment } from '../../../environments/environment';
import { Utility } from '../../_service/utility';
import { StorageService } from '../../storageprovider';
import { GuideService } from 'app/_service/guide/guide.service';
import { DnDialogService } from 'app/_modules/dn-dialog/dn-dialog.service';
import { DOCUMENT } from '@angular/common';
import { ToastService } from 'app/_service/toast/toast.service';
import { fromEvent } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { PageScrollService } from '../../_service/page-scroll/page-scroll.service';
import { animateDebounce } from '../../_service/animateDebounce';
import { SettingsService } from 'app/user-center/settings/settings.service';
import { UserService } from 'app/_service/user/user.service';
@Component({
  selector: 'app-sticky-block',
  templateUrl: './sticky-block.component.html',
  styleUrls: ['./sticky-block.component.scss']
})

export class StickyBlockComponent implements OnInit, OnDestroy {
  changeColorGuide = false;

  @Input() showStickyChat = false;

  buttons = [
    {
      name: "返回顶部",
      icon: "iconhuidaodingbu",
      action: "backToTop",
      showCommand: () => {
        return this.showBackToTopButton;
      }
    },
    // {
    //   // name: "返回旧版",
    //   name: "ifvod",
    //   icon: "",
    //   label: "backToOld",
    //   action: "backToOldVersion",
    //   showCommand: () => {
    //     return this.showBackToOldVersionButton;
    //   }
    // },
    {
      name: "简体繁体",
      icon: this.getLastLang() === 'zh-TW' ? 'iconfan' : 'iconjian',
      action: "switchLanguage",
      showCommand: () => {
        return this.showLangSwitchButton;
      }
    },
    {
      // name: "开灯/关灯",
      name: "一键换肤",
      // icon: !!parseInt(this._storage.GetConfig()["isDark"]) ? "iconheiye" : "iconbaitian",
      icon: "iconshensepifu",
      action: "openOrCloseLight",
      showCommand: () => {
        return environment.isDarkModeSupport;
      }
    },
    {
      name: "下载APP",
      icon: "iconxiazaiAPP",
      link: "/app-download",
      target: "_blank",
      showCommand: () => {
        return this.showAppDownloadButton;
      }
    },
    {
      name: "升级VIP",
      icon: "iconVIP",
      action: "openRechargeBoxService",
      showCommand: () => {
        return true;//!this.allVip;
      }
    },
    {
      name: "帮助中心",
      icon: "iconbangzhu",
      link: "/help",
      target: "_blank",
      showCommand: () => {
        return this.showHelpCenterButton;
      }
    },
    // {
    //   name: "求片(VIP)",
    //   icon: "iconqiupian",
    //   action: "vod",
    //   showCommand: () => {
    //     return this.showRequestButton && !this.allVip
    //   }

    // }


  ];
  showAppDownloadButton = true;
  //showBackToOldVersionButton = false;
  //isAdult = environment.cinema === 2;
  isIphoneDevice;
  //allVip = false;
  showBackToTopButton = false;
  showHelpCenterButton = true;
 // showRequestButton = !this.isAdult;
  @ViewChild('stickBlock') stickBlock: ElementRef;
  hide = environment.app;
  activeButton;
  // unsubscription;
  popup = {
    hint: '',
    rect: {},
    parentRect: {}
  };
  user;
  showLangSwitchButton = true;
  @ViewChild('langSwitch') langSwitch: ElementRef;
  fasterScroll = false
  constructor(
    private _rechargeBoxService: RechargeBoxService,
    private _pageScrollService: PageScrollService,
    private router: Router,
    private _storage: StorageService,
    @Inject(DOCUMENT) private document: any,
    private _guide: GuideService,
    private _dnDialogService: DnDialogService,
    private _utility: Utility,
    private _toastService: ToastService,
    private settingsService: SettingsService,
    private _userService: UserService,

  ) {
    // this.unsubscription = store.subscribe(() => this.readState());
  }
  readState() {
    // const userState: UsersState = this.store.getState()['users'] as UsersState;
    // this.user = userState.currentUser;
    // const state = this.store.getState()['config'];
    // if (state.config.allVip) {
    //   this.allVip = true;
    // }
  }
  //@HostListener('window:scroll', [])
  onWindowScroll() {
   // console.log("scrolled1")
    // 可用的数据： window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop
    if (this._utility.getWindow().scrollY > 460) {
      this.showBackToTopButton = true;
    } else {
      this.showBackToTopButton = false;
    }
  }
  subscriptions: Array<any> = [];
  ngOnInit() {
    this.isIphoneDevice = this._utility.isIphoneDevice();
    this.subscriptions.push(
      this.router.events.subscribe((evt) => {
        if (!(evt instanceof NavigationEnd)) {
          return;
        }
        if ((this.router.url).includes('/help/')) {
          this.showHelpCenterButton = false;
        } else {
          this.showHelpCenterButton = true;
        }
        if ((this.router.url).includes('/discovery')) {
          this.fasterScroll = true;
        } else {
          this.fasterScroll = false;
        }
      }),
      this._guide.colorGuide.subscribe(r => {
        this.changeColorGuide = r;
      }),
      this._userService.userState$.subscribe(user => {
        this.user = user;
      }),
      fromEvent(window,"scroll",{passive:true}).subscribe(animateDebounce(this.onWindowScroll.bind(this)).bind(this))
    );
    // if(Utility.isDarkMode() || !!parseInt(this._storage.GetConfig()["isDark"]))
    // {
    //   this.buttons[0].icon = "icon-night";
    // }
    this.getGuideState();
  }

  getGuideState() {
    const isiOS = this._utility.isIphoneDevice();
    if (!isiOS) {
      this._guide.getGuideCookie(1);
    }
  }

  backToTop() {
 
    this._pageScrollService.scroll({
      document: this.document,
      duration: this.fasterScroll ? 100 : 400,
      scrollTarget: 'body',
      easingPattern: this.fasterScroll ? 'easeOutQuart' : 'easeInOutQuart',
    });
    this.hidePopup();
  }

  backToOldVersion() {
    // window.location.href = 'https://train.ifvod.tv';
    this._dnDialogService.open('ask-leav-dialoge');
  }

  openRechargeBoxService() {
    this._rechargeBoxService.changeDisplayStatus(true);
    // this.router.navigate(['/vip-center/recharge'], { queryParams: {forOther: '0'} });
  }

  openOrCloseLight(button) {
    var isLight = !!parseInt(this._storage.GetConfig()["isDark"] || 1);
    this._storage.SetConfig({ isDark: !isLight ? 1 : 0 });
    if (isLight) {
      document.body.classList.add("light");
    }
    else {
      document.body.classList.remove("light");
    }
    this._utility.Notify("theme.change", isLight ? "light" : "dark");
    button.icon = 'iconshensepifu';
    this.closeGuide();
    // 向setting服务更新
    if (this.user && this.user.id) {
      this.settingsService.updateOneSetting({isDarkMode: !isLight});
    }
  }
  showPopup(value) {
    this.popup = { ...value, parentRect: this.stickBlock.nativeElement.getBoundingClientRect() };
    this.activeButton = value.index;
  }

  hidePopup() {
    this.popup = {
      hint: undefined,
      rect: {},
      parentRect: {}
    };
    this.activeButton = undefined;
  }

  vod() {
    // if ((this.router.url).includes('/help/')) {
    //   this.router.navigate(['/help/vod']);
    // } else {
    //   window.open('/help/vod');
    // }
    window.open('/vod');
  }

  ngOnDestroy() {
    // this.unsubscription();
    this._utility.Unsubscribe(this.subscriptions);
  }

  clickAction(item) {
    console.log(item);
    if (!!this[item.action]) {
      this[item.action](item);
    } else if (!!item.link) {
      window.open(item.link, '_blank');
    }
  }

  closeGuide() {
    if (this.changeColorGuide) {
      this._guide.setGuideCookie(1);
      let ifPlayer = false;
      if (this._utility.isUrlContains(["/watch", "/play"])) {
        ifPlayer = true;
      }
      this._guide.closeGuideCover(ifPlayer, 'color');
      this.changeColorGuide = false;
    }
  }

  getLastLang() {
    const lastLang = !!this.getCookie('googtrans') ? this.getCookie('googtrans').split('/')[2] : 'zh-CN';
    // console.log(lastLang);
    return lastLang;
  }

  getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  }

  switchLanguage(button) {
    this._toastService.showBlackToast('正在切换...');
    button.icon = this.getLastLang() === 'zh-TW' ? 'iconjian' : 'iconfan';
    // 向setting服务更新
    if (this.user && this.user.id) {
      this.settingsService.updateOneSetting({isTCMode: button.icon !== 'iconjian'});
    }
  }

  methodCalledFromOutside(name) {
    const item = this.buttons.filter(r => r.name === name)[0];
    if (!!item) {
      const stickyButton = document.getElementById(item.action);
      const clickEvent = new MouseEvent('click', {
        view: window,
        bubbles: true,
        cancelable: true
      });
      stickyButton.dispatchEvent(clickEvent);
    } else {
      console.log(`未找到 ${name} 方法`);
    }
  }
}
